import { faArrowUpRightFromSquare, faVideo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { AlertDialog, Button, buttonVariants, Pill, Typography } from '@/ui';

import type { Props } from './types';

// An anchor rather than window.open: a features string, even one that only asks
// for noopener, makes the browser open a detached popup instead of a tab in the
// counselor's window. target="_blank" implies noopener on its own.
//
// This also renders outside the router (NotificationProvider is a sibling of
// DugoutRouter), so it has to be a plain anchor either way.
const MemberJoinedAlert = ({
  alert,
  healthieUrl,
  onMinimize,
  onOpenHealthie,
  queuedCount
}: Props) => {
  return (
    <AlertDialog
      open
      dataTestId="member-joined-alert"
      icon={faVideo}
      onMinimize={() => onMinimize(alert.collapseId)}
      // The backend's sentence already names whoever is waiting, and says
      // "multiple people" once more than one member is in the meeting. Building
      // this from data instead would name only the most recent joiner.
      title={alert.text}>
      {queuedCount > 0 && <Pill color="neutral">{`${queuedCount} more waiting`}</Pill>}

      <div className="flex flex-col items-center gap-3">
        {healthieUrl ? (
          <a
            autoFocus
            className={buttonVariants({ color: 'primary', size: '3xl' })}
            href={healthieUrl}
            onClick={() => onOpenHealthie(alert)}
            rel="noreferrer"
            target="_blank">
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="shrink-0" />
            Open in Healthie
          </a>
        ) : (
          <>
            <Button disabled color="primary" size="3xl" leftIcon={faArrowUpRightFromSquare}>
              Open in Healthie
            </Button>

            <Typography variant="caption" muted>
              This appointment is not in Healthie.
              {alert.data.person_id && (
                <a
                  className="ml-1 underline"
                  href={`/people/${alert.data.person_id}/appointments/${alert.data.appointment_id}`}>
                  Open it in Dugout
                </a>
              )}
            </Typography>
          </>
        )}
      </div>
    </AlertDialog>
  );
};

export default React.memo(MemberJoinedAlert);
